module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-Regular.29b27903.woff2";